import React from 'react';
import { SearchFullNamePopup, ListInfoDocumentDialog } from 'modules/reception';
import { Link, browserHistory } from 'react-router';
import { msg } from "constants/message";
import { Reception, DuLieuHeThong } from 'api';
import { connect } from 'react-redux';
import ThongTinNguoiDungDon from './ThongTinNguoiDungDon.jsx';
import ThongTinDon from './ThongTinDon.jsx';
import { ThongTinTiepCongDan, KetQuaTiepCongDan } from 'modules/reception';
import ThongTinCoQuanTiepDan from "./ThongTinCoQuanTiepDan.jsx";
import { Toastr } from 'modules/toastr';
import { API_URL} from 'constants/config';
import moment from 'moment';
import LoadingData from 'layout/partials/LoadingData.jsx';
import { Input, DropDown, DatePicker } from 'components/tt-forms/common';
import {ConfirmDialog} from 'modules/dialog';
import { TinhTrangDon } from 'modules/reception';
import {MasterLayout} from 'layout';
import {downloadFile} from 'components/utils';
import classnames from 'classnames';

class AddReception extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataLoading: false,
      loadingDialog: false,
      thoiHan: '',
      donId: 0,
      maHoSo: '',
      ngayTiepNhan: moment(),
      taskDelete: [],
      doanDongNguoi: [],
      listDoanDiCung: [],
      dsTepDinhKem: [],
      soTiepCongDanId: 0,
      loadingSave: false,
      loadingXLD: false,
      thanhLapDon: false,
      soThuTuLuotTiep: 1,
      tongSoLuotTCD: 1,
      huongXuLy: '',
      loaiNguoiDungDonId: 'CA_NHAN',
      diaDiemGapLanhDao: '',
      lanhDaoId: 0,
      dsTaiLieuBoSung: [],
      dsTaiLieuBoSungRemove: [],
      dsTepDinhKemRemove: [],
      isFinish: false,
      isValid: true,
      isChuyenXLD: false,
      xacNhanChuyen: false,
      chuyenKiemTraDeXuatTitle: '',
      chuyenKiemTra: false,
      dsCoQuanToChucTiepDan: [],
      backConfirm: false,
      hasChange: false,
      dataView: {},
      isSave: false,
      guiYeuCauGapLanhDao: false,
      thongTinDon: {},
      fileTuChoi: {},
      fileHuongDan: {},
      yKienCheck: false,
      saveTmp: true,
      maTraCuuDialog: false,
      maTraCuu: '',
      confirmLuuHoSo: false,
      thucHienTaiGiayBienNhanTitle: '',
      daLayThongTinDonId: '',
      donViChuTri: this.props.donViChuTri
    };
  }
  componentDidMount() {
    if (this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua') {
      this.setState({huongXuLy: 'GIAI_QUYET_NGAY'});
    }
    if (this.props.params.id) {
      this.getSoTiepCongDanInfo(this.props.params.id);
    }
    if (this.props.lanhDaoList && this.props.lanhDaoList.length) {
      this.state.lanhDaoId = this.props.lanhDaoList[0].congChucId;
      this.setState({...this.state});
    }
    if(this.props.donViChuTri.length == 0) {
      DuLieuHeThong.actions.getDonViChuTri.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'donViChuTri',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
    if(this.props.donViChuTri.length == 0) {
      DuLieuHeThong.actions.getDonViHanhChinh.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'donViHanhChinh',
            data: res.data && res.data._embedded && res.data._embedded.donViHanhChinhs ? res.data._embedded.donViHanhChinhs : []
          }]
        })
      })
    }
  }

  componentWillUnmount() {

    this.props.dispatch({
      type: 'RESET_FORM'
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.removeDonCongDanId) {
      this.state.taskDelete.push({
        type: 'CONG_DAN',
        id: nextProps.removeDonCongDanId
      });
    }
    if (this.props.lanhDaoList != nextProps.lanhDaoList && nextProps.lanhDaoList.length && this.state.lanhDaoId == 0) {
      this.state.lanhDaoId = nextProps.lanhDaoList[0].congChucId;
      this.setState({...this.state});
    }
    if (nextProps.thongTinDon && nextProps.thongTinDon.donId) {
      this.setState({daLayThongTinDonId: nextProps.thongTinDon.donId});
    }
    if (nextProps.donViChuTri != this.props.donViChuTri) {
      this.state.donViChuTri = nextProps.donViChuTri;
      this.setState({...this.state})
    }
  }

  onChangeData(data) {

    let newData = {
      ...this.state,
      ...data
    };
    this.state = newData;
    this.state.hasChange = true;
    this.setState({...this.state});
  }

  onInitComponent(data) {
    let newData = {
      ...this.state,
      ...data
    };
    this.state = newData;
    this.setState({...this.state});
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value,
      hasChange: true
    });
  }

  handleChange(e) {
    this.state[e.target.name] = e.target.value;
    this.state.hasChange = true;
    this.setState({...this.state});
    if (e.target.name == 'huongXuLy') {
      this.setState({
        ghiChuXuLy: ''
      });
    }
  }

  handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.state.hasChange = true;
    this.setState({...newData});
  }

  runDeleteTask() {
    let ddnParams = [];
    this.state.taskDelete.map((item, i) => {
      if (item.type == 'CONG_DAN') {
        Reception.actions.deleteDonCongDan.request({
          id: item.id
        });
      } else if (item.type == 'DOAN_DI_CUNG') {
        ddnParams.push({
          id: item.id
        });
      }
    });
    this.state.dsTepDinhKemRemove.map((item) => {
      Reception.actions.deleteTepDinhKem.request({
        id: item
      });
    });

    if (this.state.fileTuChoi.taiLieuVanThuId) {
      Reception.actions.deleteTepDinhKem.request({
        id: this.state.fileTuChoi.taiLieuVanThuId
      });
    }
    if (this.state.fileHuongDan.taiLieuVanThuId) {
      Reception.actions.deleteTepDinhKem.request({
        id: this.state.fileHuongDan.taiLieuVanThuId
      });
    }
    this.state.thongTinDon.dsBangChungRemove.map((item) => {
      Reception.actions.deleteTaiLieuBangChung.request({
        id: item
      });
    });
    this.state.thongTinDon.dsFileCoQuanRemove.map((item) => {
      Reception.actions.deleteTaiLieuBangChung.request({
        id: item
      });
    });
    this.state.dsTaiLieuBoSungRemove.map((item) => {
      Reception.actions.deleteTaiLieuBangChung.request({
        id: item
      });
    });
    if (this.state.uyQuyen && this.state.uyQuyen.luatSu && this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove) {
      this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove.map((item) => {
        Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
    }
    if (ddnParams.length) {
      Reception.actions.deleteDoanDiCungMulti.request(null, {
        doanDiCungs: ddnParams
      });
    }
  }

  handleRemove(name, data) {
    if (name == 'DOAN_DI_CUNG' && data.doanDiCungId) {
      this.state.taskDelete.push({
        type: 'DOAN_DI_CUNG',
        id: data.doanDiCungId
      });
    } else if (name == 'CONG_DAN' && data.donCongDanId) {
      this.state.taskDelete.push({
        type: 'CONG_DAN',
        id: data.donCongDanId
      });
    }
    this.state.hasChange = true;
    this.setState({...this.state});
  }

  createTaiLieuBangChung(item, donID, stcdId, buocGQ = 'TAI_LIEU_KEM_THEO') {
    let params = {
      don: {
        id: donID
      },
      buocGiaiQuyet: buocGQ
    }
    if (item.ten) {
      params.ten = item.ten;
    }

    if (item.tinhTrang) {
      params.tinhTrangTaiLieu = item.tinhTrang;
    }
    if (item.tenFile) {
      params.tenFile = item.tenFile;
    }
    if (item.duongDan) {
      params.duongDan = item.duongDan;
    }
    if (item.required) {
      params.required = true;
    }
    if (stcdId) {
      params.soTiepCongDan = {
        id: stcdId
      };
    }
    if (item.taiLieuBangChungId) {
      params.id = item.taiLieuBangChungId;
    }
    return params;
  }

  createDSTepDinhKem(donId, data, loaiQT, buocGQ, stcdId, huongxl) {
    let listAddNew = [];
    let listUpdate = [];
    data.map((item, i) => {
      if (item.ten) {
        let params = {
          don: { id: donId },
          loaiQuyTrinh: loaiQT,
          loaiTepDinhKem: 'QUYET_DINH'
        }
        if (item.ten) {
          params.ten = item.ten;
        }
        if (buocGQ) {
          params.buocGiaiQuyet = buocGQ;
        }
        if (stcdId) {
          params.soTiepCongDan = { id: stcdId };
        }
        if (item.tenFile) {
          params.tenFile = item.tenFile;
        }
        if (item.duongDan) {
          params.duongDan = item.duongDan;
        }
        if (item.required) {
          params.required = true;
        }
        if (huongxl) {
          params.typeRequired = huongxl;
        }
        if (item.soQuyetDinh) {
          params.soQuyetDinh = item.soQuyetDinh;
        }
        if (item.ngayQuyetDinh) {
          params.ngayQuyetDinh = moment(item.ngayQuyetDinh).toISOString();
        }
        if (item.taiLieuVanThuId) {
          params.id = item.taiLieuVanThuId;
          listUpdate.push(params);
        } else {
          listAddNew.push(params);
        }
      }
    });

    if (listAddNew.length) {
      Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
    }
    if (listUpdate.length) {
      Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
    }
  }

  createTaiLieuBoSung(data) {
    let AddNewTLList = [];
    let UpdateTLList = [];

    this.state.dsTaiLieuBoSung.map((item, i) => {
      let tlParams = this.createTaiLieuBangChung(item, data.donSTCD.donId, data.soTiepCongDanId);
      if (tlParams.id)
        UpdateTLList.push(tlParams);
      else
        AddNewTLList.push(tlParams);
    });
    if (AddNewTLList.length) {
      Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
    }
    if (UpdateTLList.length) {
      Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
    }
  }

  createDonCongDan(cdData, donID, plusData, loaiCD) {
    let param = {
      phanLoaiCongDan: loaiCD,
      don: { id: donID }
    };
    if (cdData) {
      param = Object.assign(param, cdData);
    }
    if (plusData) {
      param = Object.assign(param, plusData);
    }
    return param;
  }

  createItemDoanDiCung(data, donId) {
    let params = {
      hoVaTen: data.hoVaTen,
      don: { id: donId }
    }
    if (data.diaChi) {
      params.diaChi = data.diaChi;
    }
    if (data.soDienThoai) {
      params.soDienThoai = data.soDienThoai;
    }
    if (data.cmndHoChieu) {
      params.cmndHoChieu = data.cmndHoChieu;
    }
    if (data.doanDiCungId) {
      params.id = data.doanDiCungId;
    }
    return params;
  }

  createCongDan(data, type) {
    let params = { hoVaTen: data.hoVaTen };
    if (data.tinhThanhId) {
      params.tinhThanh = { id: data.tinhThanhId };
    }
    if (data.quanHuyenId) {
      params.quanHuyen = { id: data.quanHuyenId };
    }
    if (data.phuongXaId) {
      params.phuongXa = { id: data.phuongXaId };
    }
    if (data.toThon) {
      params.toThon = data.toThon;
    }
    if (data.diaChi) {
      params.diaChi = data.diaChi;
    }
    if (data.soDienThoai) {
      params.soDienThoai = data.soDienThoai;
    }
    if (data.soCMNDHoChieu) {
      params.soCMNDHoChieu = data.soCMNDHoChieu;
    }
    if (data.noiCap) {
      params.noiCapCMND = { id: data.noiCap.value };
    }
    if (data.ngaySinh && data.ngaySinh != null) {
      params.ngaySinh = moment(data.ngaySinh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (data.ngayCap && data.ngaySinh != null) {
      params.ngayCap = moment(data.ngayCap, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (data.gioiTinh) {
      params.gioiTinh = data.gioiTinh == 'male' ? true : false;
    }
    if (data.quocTichId) {
      params.quocTich = { id: data.quocTichId };
    }
    if (data.danTocId) {
      params.danToc = { id: data.danTocId };
    }
    if (data.donCongDanId) {
      params.id = data.donCongDanId;
    }
    if (data.congDanId && type != 'NGUOI_DUOC_UY_QUYEN') {
      params.congDan = { id: data.congDanId };
    }
    return params;
  }

  hoanThanhDon() {
    this.setState({isSave: false}, () => {
      if (this.validateSubmitForm()) {
        this.setState({confirmLuuHoSo: true});
      }
    });
  }
  hoanThanhDonConfirmed() {
    this.state.isFinish = true;
    this.state.saveTmp = false;
    this.createDon();
  }
  closeXacNhanLuuHoSo() {
    this.setState({confirmLuuHoSo: false});
  }

  createDon() {
    let params = {
      coUyQuyen: this.state.flagUyQuyen,
      coThongTinCoQuanDaGiaiQuyet: this.state.thongTinDon ? this.state.thongTinDon.flagCQDaGiaiQuyet : false,
      noiDung: this.state.thongTinDon.noiDung,
      loaiVuViec: this.state.thongTinDon.loaiVuViecId,
      nguonTiepNhanDon: 'TRUC_TIEP',
      loaiNguoiDungDon: this.state.loaiNguoiDungDonId,
      thanhLapDon: this.state.thanhLapDon ? this.state.thanhLapDon : false,
      canBoXuLy: {id: this.props.userInfo.id},
      soNguoi: this.props.nguoiDungDon.length
    };

    if (this.state.daLayThongTinDonId) {
      params.daLayThongTinDonId = this.state.daLayThongTinDonId;
    }

    if (!this.state.saveTmp) {
      params.saveTmp = this.state.saveTmp;
    }

    if (this.state.thongTinDon.loaiDonId) {
      params.loaiDon = this.state.thongTinDon.loaiDonId;
    }

    if (this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI') {
      params.soNguoi = this.state.soNguoi;
    }

    if (this.state.thongTinDon.loaiDoiTuongId) {
      params.loaiDoiTuong = this.state.thongTinDon.loaiDoiTuongId;
    }

    if (this.state.thongTinDon.linhVucCap1Id) {
      params.linhVucDonThu = {id: this.state.thongTinDon.linhVucCap1Id};
    }

    if (this.state.thongTinDon.layVuViecCu) {
      params.layVuViecCu = this.state.thongTinDon.layVuViecCu;
    }

    if (this.state.thongTinDon.linhVucCap2Id) {
      params.linhVucDonThuChiTiet = {id: this.state.thongTinDon.linhVucCap2Id};
    }
    if (this.state.thongTinDon.linhVucChiTietKhac) {
      params.linhVucChiTietKhac = this.state.thongTinDon.linhVucChiTietKhac;
    }

    if (this.state.thongTinDon.flagCQDaGiaiQuyet) {
      if (this.state.thongTinDon.coQuanDaGiaiQuyetDonThu) {
        params.coQuanDaGiaiQuyetDonThu = this.state.thongTinDon.coQuanDaGiaiQuyetDonThu;
      }
      if (this.state.thongTinDon.soVanBan) {
        params.soVanBanDaGiaiQuyet = this.state.thongTinDon.soVanBan;
      }
      if (this.state.thongTinDon.ngayBanHanh) {
        params.ngayBanHanhVanBanDaGiaiQuyet = moment(this.state.thongTinDon.ngayBanHanh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }

    if (this.state.huongXuLy == 'GIAI_QUYET_NGAY') {
      params.thanhLapDon = false;
    }

    if (this.state.isChuyenXLD) {
      params.thanhLapDon = true;
      this.setState({ loadingXLD: true });
    } else {
      this.setState({ loadingSave: true });
    }
    this.runDeleteTask();
    if (this.state.donId != 0) {
      params.tongSoLuotTCD = this.state.tongSoLuotTCD;
      Reception.actions.updateDon.request({ id: this.state.donId }, params).then(res => {
        if (res.data) {
          this.state.maHoSo = res.data.maHoSo;
          this.phanLoaiDonCongDan(res.data.donId);
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          loadingSave: false,
          loadingXLD: false
        });
      });
    } else {
      Reception.actions.postDon.request(null, params).then(res => {
        if (res.data) {
          this.state.maHoSo = res.data.maHoSo;
          this.phanLoaiDonCongDan(res.data.donId);
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          loadingSave: false,
          loadingXLD: false
        });
      });
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  phanLoaiDonCongDan(donId) {
    let plusData = {};
    let AddNewDCDList = [];
    let UpdateDCDList = [];
    let AddNewTLList = [];
    let UpdateTLList = [];
    let AddNewDDCList = [];
    let UpdateDDCList = [];

    if (this.state.loaiNguoiDungDonId == 'CO_QUAN_TO_CHUC') {
      plusData = {
        tenCoQuan: this.state.tenCoQuan,
        diaChiCoQuan: this.state.diaChiCoQuan,
        soDienThoaiCoQuan: this.state.soDienThoai
      }
    }
    this.props.nguoiDungDon.map((item, i) => {
      if (item.hoVaTen) {
        let nddData = this.createCongDan(item, 'NGUOI_DUNG_DON');
        let donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUNG_DON');
        if (donCdData.id)
          UpdateDCDList.push(donCdData);
        else
          AddNewDCDList.push(donCdData);
      }
    });
    this.state.doanDongNguoi.map((item, i) => {
      if (item.hoVaTen) {
        let ddcData = this.createItemDoanDiCung(item, donId);
        if (ddcData.id){
          UpdateDDCList.push(ddcData);
        }else{
          AddNewDDCList.push(ddcData);
        }
      }
    });

    if (this.state.flagUyQuyen) {
      if (this.state.uyQuyen && this.state.uyQuyen.flagLuatSu) {
        plusData.luatSu = this.state.uyQuyen.flagLuatSu;
        if (this.state.uyQuyen.luatSu.soTheLuatSu) {
          plusData.soTheLuatSu = this.state.uyQuyen.luatSu.soTheLuatSu;
        }
        if (this.state.uyQuyen.luatSu.ngayCapTheLuatSu) {
          plusData.ngayCapTheLuatSu = moment(this.state.uyQuyen.luatSu.ngayCapTheLuatSu, 'DD/MM/YYYY').add(7, 'hours');
        }
        if (this.state.uyQuyen.luatSu.noiCapTheLuatSu) {
          plusData.noiCapTheLuatSu = this.state.uyQuyen.luatSu.noiCapTheLuatSu;
        }
        if (this.state.uyQuyen.luatSu.thongTinGioiThieu) {
          plusData.thongTinGioiThieu = this.state.uyQuyen.luatSu.thongTinGioiThieu;
        }

        this.state.uyQuyen.luatSu.dsGiayUyQuyen.map((item, i) => {
          let tlParams = this.createTaiLieuBangChung(item, donId, '', 'LUAT_SU');
          if (tlParams.id)
            UpdateTLList.push(tlParams);
          else
            AddNewTLList.push(tlParams);
        });
      } else {
        plusData.luatSu = false;
      }
      let nddData = this.createCongDan(this.props.nguoiUyQuyen, 'NGUOI_DUOC_UY_QUYEN');
      let donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUOC_UY_QUYEN');
      if (donCdData.id)
        UpdateDCDList.push(donCdData);
      else
        AddNewDCDList.push(donCdData);
    }
    this.state.thongTinDon.dsBangChung.map((item, i) => {
      let tlParams = this.createTaiLieuBangChung(item, donId);
      if (tlParams.id)
        UpdateTLList.push(tlParams);
      else
        AddNewTLList.push(tlParams);
    });

    if (AddNewDCDList.length) {
      Reception.actions.postDonCongDanMulti.request('', { donCongDans: AddNewDCDList }).then(res => {
        if (!UpdateDCDList.length) {
          this.createSoTiepCongDan(donId);
        }
      });
    }
    if (UpdateDCDList.length) {
      Reception.actions.updateDonCongDanMulti.request('', { donCongDans: UpdateDCDList }).then(res => {
        this.createSoTiepCongDan(donId);
      });
    }
    if (!AddNewDCDList.length && !UpdateDCDList.length) {
      this.createSoTiepCongDan(donId);
    }
    if (AddNewTLList.length) {
      Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
    }
    if (UpdateTLList.length) {
      Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
    }
    if (AddNewDDCList.length) {
      Reception.actions.postDoanDiCungMulti.request('', { doanDiCungs: AddNewDDCList });
    }
    if (UpdateDDCList.length) {
      Reception.actions.updateDoanDiCungMulti.request('', { doanDiCungs: UpdateDDCList });
    }
  }

  createSoTiepCongDan(donID) {
    let params = {
      canBoTiepDan: { id: this.props.userInfo.id },
      donViTiepDan: { id: this.props.userInfo.donViId },
      don: { id: donID },
      taiLieuVanThus: [],
      loaiTiepDan: 'THUONG_XUYEN',
      ngayTiepDan: this.state.ngayTiepNhan ? moment(this.state.ngayTiepNhan, 'DD/MM/YYYY').add(7, 'hours').toISOString() : moment().add(7, 'hours').toISOString(),
      noiDungTiepCongDan: this.state.ghiChuXuLy
    };

    if (this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi') {
      params.loaiTiepDan = this.props.params.type == 'dinh-ky-chinh-sua' ? 'DINH_KY' : 'DOT_XUAT';

      if (this.state.dsCoQuanToChucTiepDan.length) {
        params.coQuanToChucTiepDans = [];
        this.state.dsCoQuanToChucTiepDan.map((item, i) => {
          params.coQuanToChucTiepDans[i] = {
            chucVu: item.chucVu,
            nguoiDaiDien: item.nguoiDaiDien,
            coQuanDonVi: {id: item.ten}
          }
          if (item.coQuanToChucTiepDanId) {
            params.coQuanToChucTiepDans[i].id = item.coQuanToChucTiepDanId;
          }
        });
      }

      if (this.state.isFinish) {
        params.hoanThanhTCDLanhDao = true;
      }
      this.props.lanhDaoList.map((item, i) => {
        if (item.congChucId == this.state.lanhDaoId) {
          params.canBoTiepDan = { id: item.congChucId };
          params.donViTiepDan = { id: item.donViCongChuc.coQuanQuanLyId };
        }
      });
      if (this.state.diaDiemGapLanhDao) {
        params.diaDiemGapLanhDao = this.state.diaDiemGapLanhDao;
      }
      params.yKienXuLy = this.state.ghiChuXuLy;
      params.huongGiaiQuyetTCDLanhDao = this.state.huongXuLy;
      if (this.state.huongXuLy == 'CHO_GIAI_QUYET') {
        if (this.state.donViChuTriId) {
          params.donViChuTri = { id: this.state.donViChuTriId };
        }
        if (this.state.donViPhoiHopId) {
          params.donViPhoiHops = [];
          this.state.donViPhoiHopId.map((item) => {
            params.donViPhoiHops.push({id: item.value});
          });
        }
        if (this.state.thoiHan) {
          params.ngayBaoCaoKetQua = moment(this.state.thoiHan, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
        if (this.state.chuyenKiemTra) {
          params.chuyenDonViKiemTra = true;
          params.yKienGiaiQuyet = this.state.ghiChuXuLy;
        }
      }
    } else {
      if (this.state.huongXuLy) {
        params.huongXuLy = this.state.huongXuLy;
      }
      if (this.state.isFinish) {
        params.hoanThanhTCDThuongXuyen = true;
      }
    }

    if (this.state.guiYeuCauGapLanhDao) {
      params.guiYeuCauGapLanhDao = true;
    }

    if (this.state.soTiepCongDanId && this.props.params.type != 'them-luot') {
      params.soThuTuLuotTiep = this.state.soThuTuLuotTiep;
      Reception.actions.updateSoTiepCongDan.request({ id: this.state.soTiepCongDanId }, params).then(res => {
        if (res.data) {
          this.createDSTepDinhKem(donID, this.state.dsTepDinhKem, 'TIEP_CONG_DAN', '', res.data.soTiepCongDanId, res.data.huongXuLy);
          this.createDSTepDinhKem(donID, this.state.thongTinDon.dsFileCoQuan, 'THONG_TIN_DON', 'CO_QUAN_DA_GIAI_QUYET', res.data.soTiepCongDanId, '');
          this.createTaiLieuBoSung(res.data);
          this.props.dispatch({
            type: 'REFRESH_MENU',
            value: true
          });
          if (this.state.isChuyenXLD) {
            Toastr(msg.chuyenXLDSucess, 'success');
            this.state.thucHienTaiGiayBienNhanTitle = `Bạn có đồng ý tải xuống Giấy biên nhận của đơn với Mã đơn ${this.state.maHoSo} không?`;
            this.state.maTraCuuDialog = true;
            this.setState({...this.state});
            return;
          } else if (this.state.chuyenKiemTra) {
            Toastr(msg.chuyenKTDX, 'success');
          } else {
            Toastr(msg.updateSuccess, 'success');
          }
          setTimeout(() => {
            browserHistory.goBack();
          }, 1000);
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          loadingSave: false,
          loadingXLD: false,
          xacNhanChuyen: false
        });
      });
    } else {
      Reception.actions.postSoTiepCongDan.request('', params).then(res => {
        if (res.data) {
          this.createDSTepDinhKem(donID, this.state.dsTepDinhKem, 'TIEP_CONG_DAN', '', res.data.soTiepCongDanId, res.data.huongXuLy);
          this.createDSTepDinhKem(donID, this.state.thongTinDon.dsFileCoQuan, 'THONG_TIN_DON', 'CO_QUAN_DA_GIAI_QUYET', res.data.soTiepCongDanId, '');
          this.createTaiLieuBoSung(res.data);
          this.props.dispatch({
            type: 'REFRESH_MENU',
            value: true
          });
          if (this.state.isChuyenXLD) {
            Toastr(msg.chuyenXLDSucess, 'success');
            this.state.thucHienTaiGiayBienNhanTitle = `Bạn có đồng ý tải xuống Giấy biên nhận của đơn với Mã đơn ${this.state.maHoSo} không?`;
            this.state.maTraCuuDialog = true;
            this.setState({
              ...this.state,
              donId: donID
            });
            return;
          } else if (this.state.chuyenKiemTra) {
            Toastr(msg.chuyenKTDX, 'success');
          } else {
            if (this.props.params.type == 'them-luot') {
              Toastr(msg.addTurnSucess, 'success');
            } else {
              Toastr(msg.createSuccess, 'success');
            }
          }
          setTimeout(() => {
            browserHistory.goBack();
          }, 1000);
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          loadingSave: false,
          loadingXLD: false,
          xacNhanChuyen: false
        });
      });
    }
  }

  getSoTiepCongDanInfo(stcdId) {

    Reception.actions.getSoTiepCongDanDetail.request({ id: stcdId }).then(res => {
      if (res.data) {
        this.getSoTiepCongDanMoreInfo(res.data);
        let info = res.data;
        info.donSTCD.listNguoiDungDon.map((item, i) => {
          this.props.dispatch({
            type: 'CHON_CONG_DAN',
            data: item,
            donCongDanId: item.donCongDanId,
            index: i
          });
        });

        let newState = { ...this.state };

        if (this.props.params.type == 'them-luot') {
          newState.ngayTiepNhan = moment();
        } else {
          newState.ngayTiepNhan = moment(info.ngayTiepDan);
        }
        newState.donId = info.donSTCD.donId;
        newState.soTiepCongDanId = info.soTiepCongDanId;
        newState.soThuTuLuotTiep = info.soThuTuLuotTiep;
        newState.tongSoLuotTCD = info.donSTCD.tongSoLuotTCD;
        newState.loaiNguoiDungDonId = info.donSTCD.loaiNguoiDungDon;
        newState.thanhLapDon = info.donSTCD.thanhLapDon;
        newState.diaDiemGapLanhDao = info.diaDiemGapLanhDao;
        newState.lanhDaoId = info.canBoTiepDanInfo ? info.canBoTiepDanInfo.congChucId : 0;
        newState.maHoSo = info.donSTCD.maHoSo ? info.donSTCD.maHoSo : '';
        newState.dataView = info.donSTCD;
        newState.daLayThongTinDonId = info.donSTCD.daLayThongTinDonId || '';

        this.setState(newState);
      }
    });
  }
  getSoTiepCongDanMoreInfo(stcdData) {
    Reception.actions.getSoTiepCongDanInfo.request({ id: stcdData.soTiepCongDanId }).then(res => {
      if (res.data) {
        stcdData = {...stcdData, ...res.data};
      }
      this.getDonInfo(stcdData);
    });
  }
  getDonInfo(stcdData) {
    Reception.actions.getDonInfo.request({ id: stcdData.donSTCD.donId }).then(res => {
      if (res.data) {
        this.state.listDoanDiCung = res.data.listDoanDiCung;
        if (res.data.nguoiDuocUyQuyen) {
          this.props.dispatch({
            type: 'CHON_CONG_DAN',
            data: res.data.nguoiDuocUyQuyen,
            donCongDanId: res.data.nguoiDuocUyQuyen.donCongDanId,
            index: -1
          });
        }
        stcdData.donSTCD = {...stcdData.donSTCD, ...res.data};
        this.props.dispatch({
          type: 'INIT_EDIT_FORM',
          data: stcdData.donSTCD,
          STCD: stcdData
        });
      }
    });
  }

  chuyenXuLyDon() {
    this.setState({isSave: false}, () => {
      if (this.validateSubmitForm()) {
        this.state.isChuyenXLD = true;
        this.state.saveTmp = false;
        this.createDon();
      }
    });
  }

  luuDon() {
    this.setState({isSave: true}, () => {
      this.createDon();
    });
  }

  handleInPhieu() {
    let diaChi = '';
    let data = this.props.nguoiDungDon[0];
    let noiCap = data.noiCap ? data.noiCap.label : '...';
    let ngayCap = data.ngayCap ? moment(new Date(data.ngayCap)).format('DD/MM/YYYY') : '';
    let ngayTiepNhan = this.state.ngayTiepNhan ? moment(new Date(this.state.ngayTiepNhan)).format('DD/MM/YYYY') : '';
    if (data) {
      diaChi = diaChi + data.diaChi;
    }
    if (data && data.toThon) {
      if (data.diaChi) {
        diaChi = diaChi + ", " + data.toThon;
      } else {
        diaChi = diaChi + data.toThon;
      }
    }
    if (data && data.phuongXaCongDan) {
      if (data.diaChi || data.toThon) {
        diaChi = diaChi + ", " + data.phuongXaCongDan.ten;
      } else {
        diaChi = diaChi + data.phuongXaCongDan.ten;
      }
    }
    if (data && data.quanHuyenCongDan) {
      if (data.diaChi || data.phuongXaCongDan) {
        diaChi = diaChi + ", " + data.quanHuyenCongDan.ten;
      } else {
        diaChi = diaChi + data.quanHuyenCongDan.ten;
      }
    }
    if (data && data.tinhThanhCongDan) {
      if (data.diaChi || data.quanHuyenCongDan) {
        diaChi = diaChi + ", " + data.tinhThanhCongDan.ten;
      } else {
        diaChi = diaChi + data.tinhThanhCongDan.ten;
      }
    }

    let apiUrl = "/soTiepCongDans/inPhieuHen?";
    let name="giay_bien_nhan.doc";
    if (this.state.huongXuLy == 'TU_CHOI') {
      apiUrl = "/soTiepCongDans/inPhieuTuChoi?";
      name="phieu_tu_choi.doc";
    }
    if (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && this.state.thongTinDon.loaiDonId == 'DON_KHIEU_NAI') {
      apiUrl = "/soTiepCongDans/inPhieuHuongDanKhieuNai?";
      name="phieu_huong_dan_khieu_nai.doc";
    }
    if (this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' && this.state.thongTinDon.loaiDonId == 'DON_TO_CAO') {
      apiUrl = "/soTiepCongDans/inPhieuHuongDanToCao?";
      name="phieu_huong_dan_to_cao.doc";
    }

    let URL = String(API_URL) + apiUrl
    + "donId=" + this.state.donId
    + "&hoVaTen=" + (data.hoVaTen ? data.hoVaTen : '...')
    + "&canBoTiepNhan=" + (this.props.userInfo && this.props.userInfo.name ? this.props.userInfo.name : '...')
    + "&chucVu=" + (this.props.userInfo.chucVu ? this.props.userInfo.chucVu : '...')
    + "&maHoSo=" + (this.state.maHoSo ? this.state.maHoSo : '')
    + "&soCMNDHoChieu=" + (data.soCMNDHoChieu || '...')
    + "&ngayCap=" + ngayCap
    + "&loaiDon=" + (this.state.thongTinDon.loaiDonText || '')
    + "&noiCap=" + noiCap
    + "&diaChi=" + (diaChi ? diaChi : '...')
    + "&noiDung=" + this.state.thongTinDon.noiDung
    + "&diaDiemTiepCongDan=..."
    + "&donViXuLyId=" + this.props.userInfo.donViId
    + "&ngayTiepNhan=" + ngayTiepNhan
    + "&thoiGianTiepCongDan=..."
    + "&ngayHenTiepCongDan=...";
    // window.open(URL, "_self");
    downloadFile(URL, name, () => {
      if (name === 'giay_bien_nhan.doc') {
        this.closeMaTraCuuDialog()
      } else {
        this.closeDialogSauKhiDownFile();
      }
    }, true);
  }

  chuyenKiemTraDeXuat() {
    this.setState({
      isSave: false,
      yKienCheck: this.props.params.type == 'dinh-ky-chinh-sua'
    }, () => {
      if (this.validateSubmitForm()) {
        let tenDonVi = 'đơn vị này';
        this.state.donViChuTri.map((item) => {
          if (item.coQuanQuanLyId == this.state.donViChuTriId) {
            tenDonVi = item.ten;
          }
        });
        this.state.xacNhanChuyen = true;
        this.state.chuyenKiemTraDeXuatTitle = `Bạn có đồng ý chuyển qua ${tenDonVi} kiểm tra và đề xuất cho đơn/vụ việc này không?`;
        this.setState({...this.state});
      }
    });
  }

  closeDialogKiemTraDeXuat() {
    this.setState({
      xacNhanChuyen: false
    });
  }
  luuLuotTiep() {
    if (this.validateSubmitForm()) {
      this.createDon();
    }
  }
  chuyenYeuCau() {
    this.state.guiYeuCauGapLanhDao = true;
    if (this.validateSubmitForm()) {
      this.state.saveTmp = false;
      this.createDon();
    }
  }

  thucHienChuyenKiemTraDeXuat() {
    this.setState({
      loadingDialog: true,
      chuyenKiemTra : true,
      saveTmp : false,
      xacNhanChuyen: false
    }, () => {
      this.createDon();
    })
  }

  handleBack(allowBack) {
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        browserHistory.goBack();
      }
    }
  }
  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }
  closeDialogSauKhiDownFile() {
    this.setState({maTraCuuDialog: false, loadingDialog: false});
  }
  closeMaTraCuuDialog() {
    this.setState({maTraCuuDialog: false, loadingDialog: false});
    browserHistory.goBack();
  }
  thucHienTaiGiayBienNhan(){
    this.setState({
      loadingDialog: true
    }, () => {
      this.handleInPhieu();
    })
  }
  render() {
    let valid = (current) => {
      return current.isBefore(moment());
    };
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div>
          <ConfirmDialog open={this.state.maTraCuuDialog} loading={this.state.loadingDialog} onClose={this.closeMaTraCuuDialog.bind(this)} onSuccess={this.thucHienTaiGiayBienNhan.bind(this)}
            title={this.state.thucHienTaiGiayBienNhanTitle} />
          <SearchFullNamePopup self={this.state} />
          <ListInfoDocumentDialog self={this.state} />
          <ConfirmDialog open={this.state.xacNhanChuyen} loading={this.state.loadingDialog} onClose={this.closeDialogKiemTraDeXuat.bind(this)} onSuccess={this.thucHienChuyenKiemTraDeXuat.bind(this)}
            title={this.state.chuyenKiemTraDeXuatTitle} />
          <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
            title={msg.confirmBack} />
          <ConfirmDialog open={this.state.confirmLuuHoSo} onClose={this.closeXacNhanLuuHoSo.bind(this)} loading={this.state.loadingSave} onSuccess={this.hoanThanhDonConfirmed.bind(this)} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>

          <div id="page" className="add-reception panel-page">
            <div className="center">
              <div className="back-foward">
                <Link onClick={ this.handleBack.bind(this, false) } title="">Về trang trước</Link>
              </div>
              <div className="heading">
                <h2 className="heading-title icon-add">
                  { this.props.params.type == 'them-moi' || this.props.params.type == 'them-luot' ? 'THÊM MỚI LƯỢT TIẾP CÔNG DÂN' : '' }
                  { this.props.params.type == 'chinh-sua' ? 'CHỈNH SỬA LƯỢT TIẾP CÔNG DÂN' : '' }
                  { this.props.params.type == 'dinh-ky-chinh-sua' ? 'CHI TIẾT CUỘC TIẾP CÔNG DÂN CỦA LÃNH ĐẠO' : '' }
                  { this.props.params.type == 'dot-xuat-them-moi' ? 'THÊM MỚI CUỘC TIẾP ĐỘT XUẤT CỦA LÃNH ĐẠO' : '' }
                  { this.props.params.type == 'dot-xuat-chinh-sua' ? 'CHI TIẾT CUỘC TIẾP ĐỘT XUẤT CỦA LÃNH ĐẠO' : '' }
                </h2>
              </div>
              { this.state.dataLoading ? (
                <LoadingData/>
              ) : (
                <div className="main_page">
                  <form className="form">
                    <div className="wrapper_box">
                      <div className="box-items">
                        <div className="box-forward ">
                          <div className="container-box">
                            <div className="group-box">
                              <div className="items-form">
                                <div className="rows box-top">
                                  { this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua' ? (
                                    <div>
                                      <DropDown label="Lãnh đạo tiếp" className="col-input mb0-18" require={true} options={this.props.lanhDaoList} keyName="congChucId" valueName="hoVaTen" selectedValue={this.state.lanhDaoId} onChange={this.onChange.bind(this, 'lanhDaoId')} isValid={!this.state.isValid} name="dropdownChonLanhDaoTiep"/>
                                      <DatePicker className="col-input mb0-18" label='Ngày tiếp' dateFormat="DD/MM/YYYY -" timeFormat="HH:mm" value={this.state.ngayTiepNhan} onChange={ this.handleChangeDate.bind(this, 'ngayTiepNhan') } maxLength={18}  name="ngayTiep"/>
                                      <Input label="Địa điểm" className="col-w60 mb0-18" value={this.state.diaDiemGapLanhDao} onChange={this.onChange.bind(this, 'diaDiemGapLanhDao')} name="textDiaDiemGapLanhDao"/>
                                    </div>
                                  ) : (
                                    <div className="col-12">
                                      <DatePicker className="col-input mb0-18" label='Ngày tiếp' dateFormat="DD/MM/YYYY -" timeFormat="HH:mm" value={this.state.ngayTiepNhan} onChange={ this.handleChangeDate.bind(this, 'ngayTiepNhan') } maxLength={18} isValidDate={ valid } name="ngayTiep"/>
                                      { this.props.params.type == 'them-luot' ?
                                        <p className="pull-right reception-count">Lượt tiếp <span>{ (this.state.soThuTuLuotTiep + 1) + '/' + (this.state.tongSoLuotTCD + 1) }</span></p>
                                        : <p className="pull-right reception-count">Lượt tiếp <span>{ this.state.soThuTuLuotTiep + '/' + this.state.tongSoLuotTCD }</span></p>
                                      }
                                    </div>
                                  ) }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      { this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua' ? (
                        <ThongTinCoQuanTiepDan onChange={this.onChangeData.bind(this)} onInit={this.onInitComponent.bind(this)} bindValidator={this}/>
                      ) : null }
                      <ThongTinNguoiDungDon onChange={this.onChangeData.bind(this)} bindValidator={this} onInit={this.onInitComponent.bind(this)} onRemove={this.handleRemove.bind(this)}
                        onSave={this.state.isSave || this.state.huongXuLy == 'KHAC'}/>
                      <ThongTinDon onChange={this.onChangeData.bind(this)} isTraCuu={true} isDonCu={false} isKiemTraTCD={true} bindValidator={this} huongXuLy={this.state.huongXuLy} onInit={this.onInitComponent.bind(this)} type={this.props.params.type} onSave={this.state.isSave || this.state.huongXuLy == 'TRA_DON_VA_HUONG_DAN' || this.state.huongXuLy == 'YEU_CAU_GAP_LANH_DAO' || this.state.huongXuLy == 'TU_CHOI' || this.state.huongXuLy == 'KHAC'}/>
                      { this.props.params.type == 'chinh-sua' || this.props.params.type == 'them-luot' ?
                          <TinhTrangDon data={this.state.dataView}/>
                        : ''
                      }
                      { this.props.params.type == 'dinh-ky-chinh-sua' || this.props.params.type == 'dot-xuat-them-moi' || this.props.params.type == 'dot-xuat-chinh-sua' ?
                        <KetQuaTiepCongDan type = {this.props.params.type} yKienCheck={this.state.yKienCheck} onChange={this.onChangeData.bind(this)} bindValidator={this} onInit={this.onInitComponent.bind(this)} onSave={this.state.isSave}/>
                        :
                        <ThongTinTiepCongDan thongTinTiepCongDan={this.state.huongXuLy} loaiDon={this.state.thongTinDon.loaiDonId} onChange={this.onChangeData.bind(this)} bindValidator={this} type = {this.props.params.type} onInit={this.onInitComponent.bind(this)}
                          onSave={this.state.isSave}/>
                      }

                    </div>
                    <div className="box-bottom complete-wrap">
                      {
                        ((this.state.thongTinDon.loaiDonId !== "DON_KIEN_NGHI_PHAN_ANH" && this.state.thongTinDon.loaiDonId !== "DON_TRANH_CHAP_DAT") && this.state.huongXuLy === "TRA_DON_VA_HUONG_DAN") && ((!this.props.params.id && (this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' || this.state.huongXuLy === 'TU_CHOI')) || (this.props.params.id && this.props.params.type !== "them-luot" && this.props.params.type !== 'dinh-ky-chinh-sua')) &&
                          <Link onClick={ this.handleInPhieu.bind(this) } className="btn-action btn-print btn-print-left">
                            {
                              this.state.huongXuLy === 'TRA_DON_VA_HUONG_DAN' ?
                                <span>Tải phiếu trả đơn và hướng dẫn</span>
                              : this.state.huongXuLy === 'TU_CHOI' ?
                                <span>Tải phiếu từ chối tiếp công dân</span>
                              :
                                <span>Tải giấy biên nhận</span>
                            }
                          </Link>
                      }
                      <Link className="btn-action btn-close" onClick={ this.handleBack.bind(this, false) }>
                        <span>Đóng</span>
                      </Link>
                      <Link className={ `btn-action btn-save ${this.state.loadingSave ? 'btn-loading-inline' : ''} ${this.state.loadingXLD ? 'btn-disable' : ''}` } onClick={ this.luuDon.bind(this) }>
                        { this.props.params.type == 'them-luot' ? <span>Thêm lượt</span> : <span>Lưu tạm</span> }
                      </Link>
                      { this.state.huongXuLy == 'TIEP_NHAN_DON' && !this.state.thanhLapDon ? (
                        <Link className={classnames('btn-action btn-move right mt30', {'btn-loading-inline': this.state.loadingXLD}, {'btn-disable': this.state.loadingSave})} onClick={ this.chuyenXuLyDon.bind(this) }>
                          <span>Chuyển xử lý đơn</span>
                        </Link>
                        ) : null }
                      {
                        this.state.huongXuLy == 'YEU_CAU_GAP_LANH_DAO' && !this.state.dataView.yeuCauGapTrucTiepLanhDao ?
                          <Link className={classnames('btn-action btn-complete right', {'btn-loading-inline': this.state.loadingXLD}, {'btn-disable': this.state.loadingSave})} onClick={ this.chuyenYeuCau.bind(this) }>
                            <span>Chuyển yêu cầu</span>
                          </Link>
                        :''
                      }
                      { this.state.huongXuLy != 'TIEP_NHAN_DON' &&
                        this.state.huongXuLy != 'YEU_CAU_GAP_LANH_DAO' &&
                        this.state.huongXuLy != 'BO_SUNG_THONG_TIN' &&
                        this.state.huongXuLy != '' &&
                        this.state.huongXuLy != 'CHO_GIAI_QUYET' &&
                        this.props.route.type == 'lanhDao' ? (
                        <Link className={classnames('btn-action btn-complete right', {'btn-loading-inline': this.state.loadingXLD}, {'btn-disable': this.state.loadingSave})} onClick={ this.hoanThanhDon.bind(this) }>
                          <span>Lưu hồ sơ</span>
                        </Link>
                        ) : null }
                      { this.state.huongXuLy != 'TIEP_NHAN_DON' &&
                        this.state.huongXuLy != 'YEU_CAU_GAP_LANH_DAO' &&
                        this.state.huongXuLy != 'BO_SUNG_THONG_TIN' &&
                        this.state.huongXuLy != '' &&
                        this.state.huongXuLy != 'CHO_GIAI_QUYET' &&
                        this.props.route.type == 'thuongXuyen' ? (
                        <Link className={classnames('btn-action btn-complete right', {'btn-loading-inline': this.state.loadingXLD}, {'btn-disable': this.state.loadingSave})} onClick={ this.luuLuotTiep.bind(this) }>
                          <span>Lưu lượt tiếp</span>
                        </Link>
                        ) : null }
                      { this.state.huongXuLy == 'CHO_GIAI_QUYET' ? (
                        <Link className={classnames('btn-action btn-complete right', {'btn-loading-inline': this.state.loadingXLD}, {'btn-disable': this.state.loadingSave})} onClick={ this.chuyenKiemTraDeXuat.bind(this) }>
                          <span>Chuyển kiểm tra đề xuất</span>
                        </Link>
                        ) : null }
                    </div>
                  </form>
                </div>
                ) }
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

AddReception.defaultProps = {
  validators: {},
  donViHanhChinh: [],
  donViChuTri: []
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon,
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen,
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    donViHanhChinh: state.duLieuHeThong.donViHanhChinh,
    donViChuTri: state.duLieuHeThong.donViChuTri,
    removeDonCongDanId: state.formDataTiepCongDan.removeDonCongDanId,
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan
  };
}

export default connect(bindStateToProps)(AddReception);



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/AddReception.jsx